export default class Overlay {

    constructor(element) {
        this._element = getElement(element);
        if (!this._element) {
            throw new Error("element not found");
        }

        this.onshow = null;
        this.onhide = null;

        this._handleClick = this._handleClick.bind(this);
        this._element.addEventListener("click", this._handleClick);
    }

    addToggleButton(element) {
        const button = getElement(element);
        if (!button) {
            throw new Error("element not found");
        }

        button.addEventListener("click", ev => {
            ev.preventDefault();
            this.toggle();
        });
    }

    toggle() {
        this._element.hidden = !this._element.hidden;
        if (this._element.hidden) {
            this.onhide?.();
        } else {
            this.onshow?.();
        }
    }

    show() {
        if (this._element.hidden) {
            this._element.hidden = false;
            this.onshow?.();
        }
    }

    hide() {
        if (!this._element.hidden) {
            this._element.hidden = true;
            this.onhide?.();
        }
    }

    _handleClick(ev) {
        if (ev.target === this._element || !!ev.target.closest(".close-button")) {
            this.hide();
        }
    }

}

function getElement(idOrElement) {
    if (typeof idOrElement === "string") {
        return document.getElementById(idOrElement);
    }

    return idOrElement;
}
